module.exports = __webpack_public_path__ + "static/img/qj.e821b52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/qj.png
// module id = RfF0
// module chunks = 23